import React from 'react';

import Box from '../Box';
import { renderNodeOrComponent } from '../utils';
import { MenuItemIconComponentType, MenuItemIconNodeType } from './types';

interface Params {
  classes?: { fillColorToken?: string; icon?: string; root?: string };
  icon?: MenuItemIconNodeType;
  Icon?: MenuItemIconComponentType;
}

export const renderMenuItemIcon = (params: Params) => {
  const { classes, icon, Icon } = params;
  const renderedIcon = renderNodeOrComponent({
    Component: Icon,
    node: icon,
    props: { className: classes?.icon, fillColorToken: classes?.fillColorToken },
  });

  if (renderedIcon) {
    return <Box className={classes?.root}>{renderedIcon}</Box>;
  }

  return null;
};
